<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <RouterLink to="/">Leo-Martin</RouterLink>
        </div>
        
        <nav class="nav">
          <ul class="nav-list">
            <li class="nav-item">
              <RouterLink to="/" class="nav-link">{{ $t('nav.home') }}</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/about" class="nav-link">{{ $t('nav.about') }}</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/projects" class="nav-link">{{ $t('nav.projects') }}</RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/contact" class="nav-link">{{ $t('nav.contact') }}</RouterLink>
            </li>
          </ul>
        </nav>
        
        <div class="header-controls">
          <LanguageSelector />
          <MoodSelector />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { RouterLink } from 'vue-router'
import MoodSelector from './MoodSelector.vue'
import LanguageSelector from './LanguageSelector.vue'

export default {
  name: 'Header',
  components: {
    RouterLink,
    MoodSelector,
    LanguageSelector
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 1.5rem 0;
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--color-background);
  transition: background-color 0.5s ease, border-color 0.5s ease;
  
  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-controls {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}

.logo {
  font-size: 1.5rem;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  
  a {
    color: var(--color-text);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--color-primary);
    }
  }
}

.nav {
  &-list {
    display: flex;
    list-style: none;
    gap: 2rem;
  }
  
  &-link {
    color: var(--color-text);
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s ease;
    position: relative;
    
    &:hover, &.router-link-active {
      color: var(--color-primary);
    }
    
    &.router-link-active::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: var(--color-primary);
    }
  }
}

@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .nav-list {
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .nav-list {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>